import React from 'react';
import AllSorts from './all-sorts/AllSorts';

const Entry = () => {
	return <AllSorts />;
};

export default Entry;
